/* rv-buy-box: selection state, add to cart and the Dawn drawer handoff for snippets/rv-buy-box.liquid
   (DESIGN-SYSTEM.md §8.5–8.8, §9.1.3). All copy and numbers are server-rendered; this only toggles
   `hidden` ([data-rv-show] = option values, [data-rv-cad] = delivery frequency index), swaps the button
   label (and the price inside it, [data-rv-add-price] in [data-rv-add-price-wrap], when the markup has one: the
   shop page's cards), keeps each form's selling_plan input on the picked frequency's plan ONLY while that form's
   option is selected on Subscribe, else at value "" (Shopify's express buttons read the value and ignore
   `disabled`, so a one-time pick must carry no plan), moves Shopify's express buttons to the selected option's form
   (from its <template data-rv-pay-tpl>, so their fixed ids exist once per page) and posts to /cart/add.js.
   Subscriptions (snippets/rv-sub-plans.liquid: every matched Seal group, one plan per delivery frequency, most
   frequent first): each option radio carries '|' lists with one entry per frequency, in the chips' order:
   data-rv-plans (plan ids; the Duo "a,b" per frequency), data-rv-sub-price (the first order's price),
   data-rv-sub-then (later orders' price when it differs, else empty; optional: a missing one reads as empty),
   data-rv-say-sub; <rv-buy-box data-every> holds the sticky bar's frequency words ("a month|every 2 months").
   Events (on document): dispatches rv:flavor-change, rv:buy-change, rv:cart-add, rv:cart-error;
   listens to rv:flavor-change, rv:sticky-add (detail { target, handle }: the box inside `target` that has
   `handle` adds, else the first box inside `target`) and rv:plan-pick (detail { plan: 'sub' | 'once' }, from the
   menu's "Subscribe & save" link). URL: ?plan=sub picks the subscription on load.
   Layout "product" (<rv-buy-box data-layout="product">, the shop page; snippets/rv-buy-box.liquid): an address or a
   same-page link whose hash names an option (#peach, #raspberry, #duo: the header's Shop menu) picks it like a tap
   (rv:flavor-change, the live line) and brings the box's section into view: on load, on hashchange, and on a click,
   which also covers the header's glide (history.pushState, no hashchange) and a second click on the same link. Those
   ids aren't elements here, so the click is taken over (the address keeps its query: a preview or UTM link), and
   focus moves to the picked option's radio as an in-page link would move it (WCAG 2.4.3). Its
   galleries' thumbnail strips (rv-gallery--below) keep the current thumbnail in view, scrolling only the strip. */
(() => {
  if (customElements.get('rv-buy-box')) return;
  const D = document;
  const fire = (name, detail) => D.dispatchEvent(new CustomEvent(name, { detail }));
  const url = (k, d) => (window.routes && window.routes[k]) || d;

  class RvBuyBox extends HTMLElement {
    connectedCallback() {
      if (this.opts) return;
      this.opts = [...this.querySelectorAll('[data-rv-opt]')];
      this.btn = this.querySelector('[data-rv-add]');
      if (!this.opts.length || !this.btn) return;
      this.lbl = this.btn.querySelector('[data-rv-add-label]') || this.btn;
      this.err = this.querySelector('[data-rv-error]');
      this.live = this.querySelector('[data-rv-live]');

      /* tapping the phones' frequency dropdown is a subscription choice too: picking the frequency it already
         shows fires no change event, so the tap itself picks Subscribe */
      this.addEventListener('click', (e) => {
        if (e.target.matches('[data-rv-cad-select]') && this.setPlan('sub')) this.sync('rv:buy-change', true);
      });
      this.addEventListener('change', (e) => {
        const t = e.target;
        if (t.matches('[data-rv-opt]')) this.pick(t, 'rv:flavor-change', true);
        else if (t.matches('[data-rv-plan]')) this.sync('rv:buy-change', true);
        else if (t.matches('[data-rv-cad-pick], [data-rv-cad-select]')) {
          /* a delivery frequency is a subscription choice: it picks Subscribe too. The phones' dropdown checks the
             matching row (the rows stay the source of truth) */
          if (t.matches('[data-rv-cad-select]')) {
            const r = this.querySelector(`[data-rv-cad-pick][value="${t.value}"]`);
            if (r) r.checked = true;
          }
          this.setPlan('sub');
          this.sync('rv:buy-change', true);
        }
      });
      this.btn.addEventListener('click', (e) => {
        e.preventDefault();
        this.add();
      });
      this.querySelectorAll('form').forEach((f) =>
        f.addEventListener('submit', (e) => {
          e.preventDefault();
          this.add();
        })
      );
      if (D.querySelector('cart-drawer')) this.btn.setAttribute('aria-haspopup', 'dialog');

      /* follow the hero chips, the Short List toggle, the PDP… (never re-dispatch: no loops) */
      this.onFlavor = (e) => {
        const d = e.detail || {};
        if (d.source === this) return;
        const o = this.find(d.handle);
        if (o && o !== this.opt) this.pick(o, 'rv:buy-change');
      };
      this.onSticky = (e) => {
        const d = e.detail || {};
        const boxes = [...D.querySelectorAll('rv-buy-box')];
        let owner = boxes[0];
        if (d.target) {
          /* the box inside the target that has the bar's flavor (the shop page's '#pick' holds three cards), then
             any box inside the target, then the first box on the page */
          try {
            const inTarget = (b) => b.closest(d.target) || b.matches(d.target);
            owner =
              boxes.find((b) => inTarget(b) && (!d.handle || b.find(d.handle))) || boxes.find(inTarget) || boxes[0];
          } catch (_) {}
        }
        /* not handled when nothing can be added: the sticky bar then scrolls to the buy box instead */
        if (owner !== this || this.busy || this.opt.dataset.rvAvailable !== 'true') return;
        e.preventDefault();
        d.handled = true;
        /* the Short List's "Add Peach to cart" shows no subscription terms, so it always adds one-time; the sticky
           bar shows the picked plan's price and frequency, so it adds what the box shows */
        this.add({ once: d.source === 'short-list' });
      };
      this.onPlan = (e) => {
        if (this.setPlan((e.detail || {}).plan)) this.sync('rv:buy-change', true);
      };
      D.addEventListener('rv:flavor-change', this.onFlavor);
      D.addEventListener('rv:sticky-add', this.onSticky);
      D.addEventListener('rv:plan-pick', this.onPlan);

      /* start: ?flavor= → the page flavor restored this session (not on PDPs) → the checked radio;
         ?plan=sub → the subscription. Product layout: an option's hash (#raspberry) comes first */
      const pdp = this.dataset.context === 'pdp';
      const prod = this.dataset.layout === 'product';
      const q = new URLSearchParams(location.search);
      this.setPlan(q.get('plan'));
      const h = prod ? this.byHash(location.hash) : null;
      let o = h || this.find(q.get('flavor'));
      if (!o && !pdp) o = this.find(D.documentElement.getAttribute('data-rv-flavor'));
      o = o || this.opts.find((x) => x.checked) || this.opts[0];
      this.pick(o, (h || o.value !== this.dataset.default) && 'rv:flavor-change');
      if (prod) this.initProduct(!!h);
    }

    disconnectedCallback() {
      D.removeEventListener('rv:flavor-change', this.onFlavor);
      D.removeEventListener('rv:sticky-add', this.onSticky);
      D.removeEventListener('rv:plan-pick', this.onPlan);
      if (this.onLink) D.removeEventListener('click', this.onLink);
      if (this.onHash) window.removeEventListener('hashchange', this.onHash);
      if (this.thumbWatch) this.thumbWatch.disconnect();
    }

    /* the option a hash names ('#raspberry' → its data-rv-key or value), else null */
    byHash(hash) {
      let v = '';
      try {
        v = decodeURIComponent(String(hash || '').replace(/^#/, ''));
      } catch (_) {
        return null;
      }
      return v ? this.find(v) : null;
    }

    /* the box to the top of the screen, just under the header (the page's scroll-padding-top), so the gallery and the
       start of the product column are in view; smooth, or instant for reduced motion */
    reveal(smooth) {
      const still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.scrollIntoView({ behavior: smooth && !still ? 'smooth' : 'auto', block: 'start' });
    }

    /* focus an option's radio without scrolling (reveal() does the scrolling) */
    land(o) {
      o.focus({ preventScroll: true });
    }

    /* layout "product" (the shop page): #peach / #raspberry / #duo, and the galleries' thumbnail strips */
    initProduct(fromHash) {
      /* a hash on arrival: the browser found no element with that id, so bring the box into view ourselves, once
         layout has settled */
      if (fromHash) requestAnimationFrame(() => requestAnimationFrame(() => this.reveal(false)));

      this.onLink = (e) => {
        if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
        const a = e.target && e.target.closest && e.target.closest('a[href*="#"]');
        if (!a || (a.target && a.target !== '_self') || a.hasAttribute('download')) return;
        let u;
        try {
          u = new URL(a.href, location.href);
        } catch (_) {
          return;
        }
        if (u.origin !== location.origin || u.pathname !== location.pathname) return;
        const o = this.byHash(u.hash);
        if (!o) return;
        /* another handler already moved the page (an element with that id exists): just pick */
        const moved = e.defaultPrevented;
        if (!moved) {
          e.preventDefault();
          if (location.hash !== u.hash) history.pushState(null, '', location.pathname + location.search + u.hash);
        }
        if (o !== this.opt) this.pick(o, 'rv:flavor-change', true);
        if (!moved) {
          this.reveal(true);
          /* like an in-page anchor, the next Tab starts from the box: focus the picked option's radio (no jump; its
             tile's ring shows for keyboard users only, :focus-visible) */
          this.land(o);
        }
      };
      D.addEventListener('click', this.onLink);

      /* the address's hash changed some other way (typed, back / forward between two picks) */
      this.onHash = () => {
        const o = this.byHash(location.hash);
        if (!o) return;
        if (o !== this.opt) this.pick(o, 'rv:flavor-change', true);
        this.reveal(true);
        this.land(o);
      };
      window.addEventListener('hashchange', this.onHash);

      /* rv-gallery.js marks the current thumbnail (aria-current) and keeps a VERTICAL column scrolled; the strip under
         the main image scrolls sideways, so keep its current thumbnail in view here (only the strip moves, never
         the page) */
      if (typeof MutationObserver !== 'function') return;
      this.thumbWatch = new MutationObserver((list) => {
        list.forEach((m) => {
          const t = m.target;
          if (t.getAttribute('aria-current') !== 'true') return;
          const strip = t.parentElement;
          if (!strip || strip.scrollWidth <= strip.clientWidth) return;
          const b = strip.getBoundingClientRect();
          const r = t.getBoundingClientRect();
          const pad = 6;
          if (r.left < b.left + pad) strip.scrollLeft += r.left - b.left - pad;
          else if (r.right > b.right - pad) strip.scrollLeft += r.right - b.right + pad;
        });
      });
      this.querySelectorAll('.rv-gallery--below [data-rv-thumb]').forEach((t) =>
        this.thumbWatch.observe(t, { attributes: true, attributeFilter: ['aria-current'] })
      );
    }

    /* the visible once/sub radios only (a radio with the hidden attribute is never picked from here) */
    setPlan(v) {
      if (v !== 'sub' && v !== 'once') return false;
      const r = this.querySelector(`[data-rv-plan][value="${v}"]`);
      if (!r || r.hidden || r.checked) return false;
      r.checked = true;
      return true;
    }

    find(v) {
      if (!v) return null;
      v = String(v).toLowerCase();
      return this.opts.find((o) => o.value.toLowerCase() === v || o.dataset.rvKey === v) || null;
    }

    sub() {
      const p = this.querySelector('[data-rv-plan]:checked');
      return !!(p && p.value === 'sub' && this.opt && this.opt.dataset.rvPlans);
    }

    /* the picked delivery frequency (0 = the most frequent plan), clamped to what option o has (sync() re-picks
       chip 0 first, so this only guards). Lists are '|'-separated, one entry per frequency: data-rv-plans
       ("id|id", the Duo "a,b|a,b"), -sub-price, -sub-then, -say-sub */
    cad(o) {
      const c = this.querySelector('[data-rv-cad-pick]:checked');
      const n = String(((o || this.opt || {}).dataset || {}).rvPlans || '').split('|').length;
      return Math.max(0, Math.min(c ? +c.value || 0 : 0, n - 1));
    }

    at(list, o) {
      const a = String(list || '').split('|');
      return a[Math.min(this.cad(o), a.length - 1)] || '';
    }

    /* read by rv-sticky-atc; null until the box has initialized */
    get state() {
      if (!this.opt) return null;
      const d = this.opt.dataset;
      const sub = this.sub();
      return {
        handle: this.opt.value,
        key: d.rvKey,
        name: d.rvName,
        accent: d.rvAccent,
        deep: d.rvDeep,
        tint: d.rvTint,
        accent2: d.rvAccent2 || '',
        price: sub ? this.at(d.rvSubPrice) : d.rvPrice,
        /* later orders' price when the first order is cheaper ("$27.99"), else '' */
        then: sub ? this.at(d.rvSubThen) : '',
        plan: sub ? 'sub' : 'once',
        every: sub ? this.at(this.dataset.every) : '',
        label: d.rvLabel,
        available: d.rvAvailable === 'true',
        source: this,
      };
    }

    pick(o, evt, say) {
      o.checked = true;
      this.opt = o;
      this.sync(evt, say);
    }

    sync(evt, say) {
      const o = this.opt;
      const d = o.dataset;
      const k = o.value;
      /* a frequency this option doesn't have (its chip is hidden): back to the first one, so the chip, the
         prices on screen and the plan that's added always agree */
      const cp = this.querySelector('[data-rv-cad-pick]:checked');
      if (cp && d.rvPlans && (+cp.value || 0) >= d.rvPlans.split('|').length) {
        const c0 = this.querySelector('[data-rv-cad-pick][value="0"]');
        if (c0) c0.checked = true;
      }
      const sub = this.sub();
      const ok = d.rvAvailable === 'true';
      const c = String(this.cad());
      this.querySelectorAll('[data-rv-show], [data-rv-cad]').forEach((el) => {
        const s = el.dataset.rvShow;
        el.hidden = (s != null && !s.split(' ').includes(k)) || (el.dataset.rvCad != null && el.dataset.rvCad !== c);
      });
      /* the phones' frequency dropdown mirrors the rows: the same pick, and a frequency this option lacks is off */
      const cs = this.querySelector('[data-rv-cad-select]');
      if (cs) {
        cs.value = c;
        [...cs.options].forEach((op) => {
          const r = this.querySelector(`[data-rv-cad-pick][value="${op.value}"]`);
          const w = r && r.closest('[data-rv-show]');
          op.disabled = !!(w && w.hidden);
        });
      }
      /* express checkout: only the selected option's form is live (the Duo's has no buttons). Shopify's
         buttons carry fixed ids, so the old option's copy leaves the document before the new one goes in. */
      const forms = [...this.querySelectorAll('form[data-rv-for]')];
      forms.forEach((f) => {
        const on = f.dataset.rvFor === k;
        f.classList.toggle('is-off', !on);
        f.inert = !on;
        const sp = f.querySelector('[name="selling_plan"]');
        if (sp) {
          const fo = this.opts.find((x) => x.value === f.dataset.rvFor);
          const id = fo && this.at(fo.dataset.rvPlans, fo).split(',')[0];
          /* Shopify's express buttons read this input's VALUE (form.elements.namedItem) and ignore `disabled`:
             one-time = ''. A hidden input's .value writes its value attribute, which Shopify's form observer
             watches: it then sets has-selling-plan and shows or hides its subscription consent line. */
          const want = on && sub && id ? id : '';
          if (sp.value !== want) sp.value = want;
          sp.disabled = !want;
        }
        if (!on) this.pay(f, false);
      });
      forms.forEach((f) => f.dataset.rvFor === k && this.pay(f, true));
      /* the colors follow the pick even before rv-flavor-state runs */
      ['accent', 'deep', 'tint'].forEach((t) => {
        const v = d['rv' + t[0].toUpperCase() + t.slice(1)];
        if (v) this.style.setProperty('--rv-flavor-' + t, v);
      });
      this.btn.setAttribute('form', d.rvForm);
      this.btn.disabled = !ok;
      if (ok) this.btn.removeAttribute('aria-disabled');
      else this.btn.setAttribute('aria-disabled', 'true');
      if (!this.busy) this.lbl.textContent = ok ? d.rvLabel : this.dataset.soldOut;
      /* the price inside the button (the shop page's cards: "Add Peach · $34.99"), the picked plan's price;
         add() swaps only the label, and the cards' CSS hides the price while the button is busy */
      const ap = this.btn.querySelector('[data-rv-add-price]');
      if (ap) {
        const t = (sub ? this.at(d.rvSubPrice) : d.rvPrice) || '';
        ap.textContent = t;
        const w = ap.closest('[data-rv-add-price-wrap]');
        if (w) w.hidden = !ok || !t;
      }
      if (this.err) this.err.hidden = true;
      if (say) this.say(sub ? this.at(d.rvSaySub) : d.rvSay);
      if (evt) fire(evt, this.state);
    }

    /* Shopify's express buttons for form f: in the document only while f's option is selected, from a
       fresh copy of the server-rendered <template data-rv-pay-tpl>, whose ids are parked as data-rv-ident
       (the custom element initializes on insertion; PaymentButton.init is Dawn's call for the same swap
       and is a no-op once loaded) */
    pay(f, on) {
      const slot = f.querySelector('[data-rv-pay]');
      const tpl = f.querySelector('template[data-rv-pay-tpl]');
      if (!slot || !tpl) return;
      if (!on) {
        if (slot.childElementCount) slot.replaceChildren();
        return;
      }
      if (slot.childElementCount) return;
      const frag = D.importNode(tpl.content, true);
      frag.querySelectorAll('[data-rv-ident]').forEach((el) => {
        el.id = el.dataset.rvIdent;
        el.removeAttribute('data-rv-ident');
      });
      slot.append(frag);
      const pb = window.Shopify && window.Shopify.PaymentButton;
      if (pb && typeof pb.init === 'function') pb.init();
    }

    say(t) {
      if (!this.live || !t) return;
      this.live.textContent = '';
      setTimeout(() => (this.live.textContent = t), 60);
    }

    fail(msg) {
      if (!this.err) return;
      this.err.hidden = false;
      const t = this.err.querySelector('[data-rv-error-text]') || this.err;
      t.textContent = msg;
    }

    async add(opts) {
      const d = this.opt.dataset;
      if (this.busy || d.rvAvailable !== 'true') return;
      const plans = this.sub() && !(opts && opts.once) ? this.at(d.rvPlans).split(',') : [];
      const items = d.rvIds.split(',').map((id, i) => {
        const it = { id: +id, quantity: 1 };
        if (plans[i]) it.selling_plan = +plans[i];
        return it;
      });
      const cart = D.querySelector('cart-drawer');
      const body = { items };
      if (cart && cart.getSectionsToRender) {
        body.sections = cart.getSectionsToRender().map((s) => s.id);
        body.sections_url = location.pathname;
      }

      const b = this.btn;
      const label = this.lbl.textContent;
      this.busy = true;
      b.style.minWidth = b.offsetWidth + 'px';
      b.setAttribute('aria-busy', 'true');
      this.lbl.textContent = this.dataset.adding;
      if (this.err) this.err.hidden = true;

      /* Dawn 16's storefront standard events (window.StandardEvents), like product-form.js */
      const SE = window.StandardEvents || {};
      const lines = SE.CartLinesUpdateEvent && SE.CartLinesUpdateEvent.createPromise();
      /* a failed add rejects it; the error line covers that, so no unhandled rejection in the console */
      if (lines && lines.promise && lines.promise.catch) lines.promise.catch(() => {});
      if (lines) {
        this.dispatchEvent(
          new SE.CartLinesUpdateEvent({
            action: 'add',
            context: 'product',
            lines: items.map((i) => ({ merchandiseId: String(i.id), quantity: 1 })),
            promise: lines.promise,
          })
        );
      }

      try {
        const r = await fetch(url('cart_add_url', '/cart/add') + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: JSON.stringify(body),
        });
        const res = await r.json().catch(() => ({}));
        if (!r.ok || res.status) {
          /* Shopify's own description (e.g. a quantity limit) is shown verbatim */
          const e = new Error(res.description || res.message || '');
          e.shopify = !!(res.description || res.message);
          throw e;
        }

        if (lines) {
          fetch(url('cart_url', '/cart') + '.js')
            .then((x) => x.json())
            .then((c) => lines.resolve({ cart: SE.CartLinesUpdateEvent.createCartFromAjaxResponse(c) }))
            .catch((x) => lines.reject(x));
        }
        fire('rv:cart-add', { items: res.items || items, source: this });
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'rv-buy-box', cartData: res });
        }

        if (cart && res.sections) {
          res.id = res.items && res.items[0] && res.items[0].id;
          cart.classList.remove('is-empty');
          if (cart.setActiveElement) cart.setActiveElement(D.activeElement);
          try {
            cart.renderContents(res);
          } catch (_) {
            location.href = url('cart_url', '/cart');
          }
        } else {
          location.href = url('cart_url', '/cart');
        }
        this.say(this.dataset.added);
      } catch (e) {
        if (lines) lines.reject(e);
        const msg = e.shopify ? e.message : this.dataset.error;
        this.fail(msg);
        fire('rv:cart-error', { message: msg, source: this });
        if (SE.CartErrorEvent) {
          this.dispatchEvent(new SE.CartErrorEvent({ error: e.message || 'Network error', code: e.shopify ? 'INVALID' : 'SERVICE_UNAVAILABLE' }));
        }
      } finally {
        this.busy = false;
        b.removeAttribute('aria-busy');
        b.style.minWidth = '';
        this.lbl.textContent = this.opt.dataset.rvAvailable === 'true' ? this.opt.dataset.rvLabel : label;
      }
    }
  }

  customElements.define('rv-buy-box', RvBuyBox);
})();
